/* eslint-disable */
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface DashboardMetricsResponse {
  totalProjects: number;
  projectsGrowth: number;
  totalOrganizations: number;
  organizationsGrowth: number;
  totalEmployees: number;
  employeesGrowth?: number;
  completedTasks?: number;
  taskCompletionChange?: number;
}

const fetchMetrics = async (): Promise<DashboardMetricsResponse> => {
  const { data } = await customAxios.get<DashboardMetricsResponse>(
    "/super-admin/dashboard-metrics"
  );
  return data;
};

export const useDashboardMetrics = () =>
  useQuery<DashboardMetricsResponse, AxiosError>(
    ["dashboard-metrics"],
    fetchMetrics,
    {
      onError: (error) =>
        showNotification({
          title: "Error loading dashboard metrics",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load dashboard metrics",
          color: "red",
        }),
      retry: 1,
      refetchOnMount: "always",
    }
  );
